export default {
    message: {
        hello: 'merhaba',
        home: 'Example App',
        about: "Hakkımızda",
        contact: "İletişim",
        homePage: "Anasayfa",
        aboutPage: "Hakkımızda",
        contactPage: "İletişim",
        login: "Giriş",
        send: "Gönder",
        logout: 'Çıkış',
        name: "İsim",
        email: "Email",
        password: "Şifre",
        locale: "Dil",
        localeSelect: "Dil Seçiniz",
        name: "İsim",
        email: "Email",
        phonenumber: "Telefon No",
        country_code: "Ülke",
        text: "Mesaj",

    },
    data: {
        home: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Consequuntur perspiciatis facilis illum modi. Dignissimos beatae placeat eos asperiores atque debitis recusandae nostrum dolorum culpa minus ut magnam, expedita assumenda quae.",
        about: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Consequuntur perspiciatis facilis illum modi. Dignissimos beatae placeat eos asperiores atque debitis recusandae nostrum dolorum culpa minus ut magnam, expedita assumenda quae.Lorem ipsum dolor, sit amet consectetur adipisicing elit. Consequuntur perspiciatis facilis illum modi. Dignissimos beatae placeat eos asperiores atque debitis recusandae nostrum dolorum culpa minus ut magnam, expedita assumenda quae.Lorem ipsum dolor, sit amet consectetur adipisicing elit. Consequuntur perspiciatis facilis illum modi. Dignissimos beatae placeat eos asperiores atque debitis recusandae nostrum dolorum culpa minus ut magnam, expedita assumenda quae."
    },
    contact: {
    }
}
